<!-- copyright section start-->
<footer class="yoga copyright copyright-bg">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-12">
                <div class="text-center">
                    <div class="social-link link-horizontal">
                        <ul class="justify-content-center">
                            <li><a href="https://www.facebook.com/PetroVorsterandPartners" class="copyright-text"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-md-12 col-12">
                <div class="text-center">
                    <div class="social-link link-horizontal">
                        <hr>
                    </div>
                </div>
            </div>

            <div class="col-md-12 col-12">
                <div class="m-l-auto center-para">
                    <h6 class="copyright-text text-center text-white">© Blouberg Physio</h6>
                </div>
            </div>

        </div>

    </div>
    <div class="row">
      <div class="col-md-12 col-12">
        <div class="m-l-auto center-para">
            <h6 class="copyright-text text-center text-white">Website Designed by Andre Smith</h6>
        </div>
    </div>
    </div>

</footer>
<!-- copyright section end-->
<!-- <div *ngIf="displayScrollToTop">
  <app-tap-to-top ></app-tap-to-top>
</div> -->

